// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCiRhp6i8o5Xq-xqmhJNRxK6FrV4wp-B4Q",
  authDomain: "homie-86a6a.firebaseapp.com",
  projectId: "homie-86a6a",
  storageBucket: "homie-86a6a.firebasestorage.app",
  messagingSenderId: "227706861660",
  appId: "1:227706861660:web:f91d06ab1eebaae3278e99",
  measurementId: "G-QHR54JTM8Z"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
